import { render } from "./UserMain.vue?vue&type=template&id=aca9a816&scoped=true"
import script from "./UserMain.vue?vue&type=script&lang=js"
export * from "./UserMain.vue?vue&type=script&lang=js"

import "./UserMain.vue?vue&type=style&index=0&id=aca9a816&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aca9a816"]])

export default __exports__